import { Button, ButtonGroup, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { addCustomer ,  resetCustomer , fetchAllCustomers} from "../../redux/features/customer.features";

const initialValues = {
  firstName: "",
  lastName: "",
  homeAddress: "",
  country: "",
  city: "",
  mobile: "",
  email: "",
  status: "Active",
  businessName: "",
  businessAddress: "",
  businessEmail: "",
  businessEmail2: "",
  businessContact: "",
  businessContact2: "",
  //new added fields
  businessVatNumber:"",
  businessCountry:"",
  businessCity:"",
  faxNumber:""

};

const CustomerEntry = (props) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState(initialValues);

  // const customerState = useSelector(state=> state.customerReducer)
  let customerState = useSelector((state) => {
    return state.customerReducer;
  });

  let { customers, loading, editCustomer, customerUpdated } = customerState;
  const {customerAdded} = customerState;
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name,value)
    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(() => {
   if(customerAdded){
      dispatch(resetCustomer())
      alert("New Customer added successfully")
      setValues(initialValues)
      dispatch(fetchAllCustomers())
      props.Close()
   }
  }, [customerAdded])
  
  const cancelCustomer = ()=>{
    setValues(initialValues);
    props.Close()
  }

 

  const saveCustomer = ()=>{

    if(values.firstName ==="") return alert("Cannot save customer without First Name")
    if(values.email ==="") return alert("Cannot save customer without Personal EMail address")
    if(values.businessAddress ==="") return alert("Cannot save customer without Business Address")
    if(values.businessEmail ==="") return alert("Cannot save customer without Business Email ")
   

    dispatch(addCustomer(values))
  }

  return (
    <div className="flex  w-full flex-wrap">
      <div className="flex w-6/12 flex-col p-2">
        <h1>Customer Personal Details</h1>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            
            label="Customer id"
            
            color="warning"
            name="id"
            disabled
            onChange={handleChange}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
  
          <TextField
            fullWidth
            required
            
            label="firstName"
            placeholder="John..."
            name="firstName"
            
            color="warning"
            onChange={handleChange}
            value={values.firstName}
          />
          <TextField
            fullWidth
            required
             
            
            label="lastName"
            placeholder="lastName"
            
            color="warning"
            name="lastName"
            value={values.lastName}
            onChange={handleChange}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            type="number"
            
            label="mobile"
            placeholder="mobile"
            name="mobile"
            
            color="warning"
            onChange={handleChange}
            value={values.mobile}
          />
          <TextField
            fullWidth
            required
            type="email"
            
            label="email"
            placeholder="email"
            name="email"
            
            color="warning"
            onChange={handleChange}
            value={values.email}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            multiline
            rows={4}
            
            label="homeAddress"
            placeholder="homeAddress"
            
            color="warning"
            name="homeAddress"
            value={values.homeAddress}
            onChange={handleChange}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <CustomSelectBox
            items={[
              "Sri Lanka",
              "Singapore",
              "Tanzania",
              "USA",
              "UK",
              "Madagascar",
            ]}
            onChange={handleChange}
            title="country"
            name="country"
            value={values.country}
          />
          <TextField
            fullWidth
            required
            
            label="city"
            placeholder="city"
            name="city"
            
            color="warning"
            onChange={handleChange}
            value={values.city}
          />
        </div>
      </div>
      <div className="flex w-6/12 flex-col p-2">
        <h1>Business Details</h1>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            
            label="Company Name"
            
            color="warning"
            name="businessName"
            value={values.businessName}
            onChange={handleChange}
          />
        </div>
      
        
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            
            label="Company Email"
            
            color="warning"
            name="businessEmail"
            value={values.businessEmail}
            type="email"
            onChange={handleChange}
          />{" "}
          <TextField
            fullWidth
            required
            
            label="Company Email 2"
            
            color="warning"
            
            type="email"
            name="businessEmail2"
            value={values.businessEmail2}
            onChange={handleChange}
          />
        </div>
        
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required            
            label="Company Contact 1"            
            color="warning"
            name="businessContact"
            value={values.businessContact}
            type="number"
            onChange={handleChange}
          />
          <TextField
            fullWidth
            required            
            label="Company Contact 2"            
            color="warning"            
            type="number"
            name="businessContact2"
            value={values.businessContact2}
            onChange={handleChange}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required
            multiline
            rows={4}
            
            label="businessAddress"
            placeholder="businessAddress"
            
            color="warning"
            name="businessAddress"
            value={values.businessAddress}
            onChange={handleChange}
          />
          
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required            
            label="Company City"            
            color="warning"
            name="businessCity"
            value={values.businessCity}            
            onChange={handleChange}
          />
        
      

<CustomSelectBox
            items={[
              "Sri Lanka",
              "Singapore",
              "Tanzania",
              "USA",
              "UK",
              "Madagascar",
            ]}
            onChange={handleChange}
            title="Country"
            name="businessCountry"
            value={values.businessCountry}
          />
        </div>
        <div className="flex w-full justify-evenly m-1">
          <TextField
            fullWidth
            required            
            label="Fax No."            
            color="warning"
            name="faxNumber"
            value={values.faxNumber}
            type="text"
            onChange={handleChange}
          />
          <TextField
            fullWidth
            required            
            label="Company Vat No."            
            color="warning"
            name="businessVatNumber"
            value={values.businessVatNumber}
            type="text"
            onChange={handleChange}
          />
           
        </div>

        <div className="flex w-full justify-evenly m-1">
        <CustomSelectBox
          items={["Active", "DeActive"]}
          onChange={handleChange}
          title="Status"
          name="status"
          value={values.status}
        />
        </div>
        <div className="flex w-full justify-evenly m-1">
         <div onClick={(e) => cancelCustomer()} className="m-1 flex w-6/12 text-white items-center font-bold justify-center uppercase text-sm bx bxs-x-square bg-red-600 cursor-pointer hover:bg-red-700 p-3">Cancel</div>
         <div onClick={(e) => saveCustomer()} className="m-1 flex w-6/12 text-white items-center font-bold justify-center uppercase text-sm bx bx-save bg-green-600 cursor-pointer hover:bg-green-700 p-3">Save</div>
        </div>
      </div>
      <div className="flex w-3/12 justify-start items-center p-2">
       
      </div>
      {/* <div className="flex w-3/12 justify-end items-center p-2">
        <ButtonGroup
          fullWidth
          variant="contained"
          aria-label="outlined primary button group"
        >
          <Button color="warning">Cancel</Button>

          <Button
            onClick={(e) => dispatch(addCustomer(values))}
            color="success"
          >
            Save
          </Button>
        </ButtonGroup>
      </div> */}
    </div>
  );
};

export default CustomerEntry;
